var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuicksale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    foxified: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 28.214L28.5291 10.6173C30.5264 8.90525 33.4736 8.90525 35.4709 10.6173L56 28.214",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 56.0001H8",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6628 15.9249V10C41.6628 8.89543 42.5583 8 43.6628 8H50.5719C51.6765 8 52.5719 8.89543 52.5719 10V25.2757",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4281 25.2756V55.9999",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4456 34.6667H37.8347C36.085 34.6669 34.6667 36.0854 34.6667 37.8351V44.4443C34.6678 45.2854 35.003 46.0916 35.5985 46.6855L43.9844 55.0722C45.2222 56.3093 47.2283 56.3093 48.4662 55.0722L55.0724 48.4676C56.3093 47.2295 56.3093 45.2234 55.0724 43.9853L46.6865 35.5986C46.0927 35.0031 45.2866 34.6678 44.4456 34.6667V34.6667Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4196 41.4193C41.3734 41.4656 41.3734 41.5406 41.4197 41.5869C41.466 41.6331 41.541 41.6331 41.5873 41.5868C41.6336 41.5406 41.6336 41.4655 41.5874 41.4192C41.5411 41.373 41.4661 41.3729 41.4198 41.4191L41.4196 41.4193",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuicksale);
export default __webpack_public_path__ + "static/media/quicksale.78ca80a4717c391766e8632307f6af31.svg";
export { ForwardRef as ReactComponent };